import React, {ReactElement, useCallback, useRef} from 'react';

import Modal, {ModalHandle, ModalProps} from './Modal';

type ModalButtonProps = ModalProps & {
  button: ReactElement;
};

const ModalButton = ({children, button, ...props}: ModalButtonProps): ReactElement => {
  const modalRef = useRef<ModalHandle>(null);

  const handleButtonClick = useCallback(() => modalRef.current && modalRef.current.open(), [modalRef]);
  const ButtonElement = React.cloneElement(button, {onClick: handleButtonClick});

  return (
    <>
      {ButtonElement}
      <Modal ref={modalRef} {...props}>
        {children}
      </Modal>
    </>
  );
};

export default ModalButton;
